module.exports = __webpack_public_path__ + "img/icon-iosC-2.f73191fb.png";